export default __webpack_public_path__ + "static/disposingCondom-cd696abb129af61fb9758b5cf1c55ce1.svg";